import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button', 'fullButton', 'pauseIcon', 'playIcon', 'video']

  connect() {
    this.detailVideoActive = false
    this.syncState()
  }

  toggle() {
    if (this.detailVideoActive || !this.hasButtonTarget) {
      return
    }

    if (this.videoTarget.paused) {
      this.videoTarget.play()
    } else {
      this.videoTarget.pause()
    }

    this.syncState()
  }

  playDetailVideo() {
    const detailSrc = this.getDetailVideoSrc()

    if (!detailSrc) {
      return
    }

    this.detailVideoActive = true
    this.element.classList.add('is-detail-video-active')

    this.videoTarget.pause()
    this.videoTarget.setAttribute('src', detailSrc)
    this.videoTarget.muted = false
    this.videoTarget.loop = false
    this.videoTarget.autoplay = false
    this.videoTarget.controls = true

    const detailPoster = this.element.dataset.detailVideoPoster
    if (detailPoster) {
      this.videoTarget.setAttribute('poster', detailPoster)
    }

    this.videoTarget.load()
    this.videoTarget.play()

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('hidden', 'hidden')
    }

    if (this.hasFullButtonTarget) {
      this.fullButtonTarget.setAttribute('hidden', 'hidden')
    }
  }

  syncState() {
    if (!this.hasButtonTarget) {
      return
    }

    const isPaused = this.videoTarget.paused

    this.buttonTarget.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video')
    this.buttonTarget.setAttribute('aria-pressed', String(!isPaused))
    this.buttonTarget.classList.toggle('is-paused', isPaused)
  }

  getDetailVideoSrc() {
    const detailMp4 = this.element.dataset.detailVideoMp4
    const detailWebm = this.element.dataset.detailVideoWebm

    if (detailWebm && this.videoTarget.canPlayType('video/webm')) {
      return detailWebm
    }

    return detailMp4
  }
}
